import { render, staticRenderFns } from "./DsdList.vue?vue&type=template&id=d36a2a40"
import script from "./DsdList.vue?vue&type=script&lang=js"
export * from "./DsdList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports